import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import format from 'date-fns/format';
import PdfIcon from 'components/atoms/icons/pdfIcon';
import withLoader from 'components/organisms/withLoader';
import common from 'constants/common';
import { convertSecondsToTime } from 'utils/timeHelper';

const InteractiveTime = ({ patientGuid, patientDetailsLoading, patient }) => {
  const interactiveTimeLoading = useSelector(
    (state) => state.loading.effects.patient.getInteractiveTime,
  );

  const {
    patient: { getInteractiveTime },
  } = useDispatch();

  useEffect(() => {
    getInteractiveTime(patientGuid);
  }, [patientGuid]);

  return (
    <div className="interactive-time">
      {withLoader(
        patientDetailsLoading || interactiveTimeLoading,
        <>
          <div className="interactive-time-header">
            <h3>Interactive Time</h3>
            <PdfIcon />
          </div>
          <div className="interactive-time-body">
            <div className="time-item">
              <strong>
                {format(new Date(), common.dateFormats.interactiveTime)}
              </strong>
              <p>{convertSecondsToTime(patient.interactiveTime?.clinicTime)}</p>
              <span>Clinic</span>
            </div>
            <div className="time-item">
              <strong>
                {format(new Date(), common.dateFormats.interactiveTime)}
              </strong>
              <p>{convertSecondsToTime(patient.interactiveTime?.totalTime)}</p>
              <span>Total</span>
            </div>
          </div>
        </>,
      )}
    </div>
  );
};
InteractiveTime.propTypes = {
  patientGuid: PropTypes.string.isRequired,
  patientDetailsLoading: PropTypes.bool.isRequired,
  patient: PropTypes.shape(),
};

export default InteractiveTime;
